export default __webpack_public_path__ + "static/media/share-icon.fa407cd1.svg";